export default __webpack_public_path__ + "static/SurfaceImperfections003_1K_var1-2af01a146cbccd80d5313b9d0cdc6b84.jpg";